/**
 * Rules for setting a new password (signup and reset). Keep in sync with
 * Supabase → Authentication → Email: minimum length 8, "Lowercase, uppercase
 * letters, digits and symbols". Supabase enforces them too; checking here
 * gives a clearer error first.
 *
 * Not applied at sign-in, so older 6-character passwords keep working.
 */
export const PASSWORD_HINT = 'At least 8 characters, with uppercase, lowercase, a number and a symbol';

// The symbols Supabase accepts. A character outside this set (é, €, a space)
// doesn't count as the required symbol there, so it mustn't count here either.
const SYMBOLS = "!@#$%^&*()_+-=[]{};'\\:\"|<>?,./`~";

/** Returns a message for the user, or null when the password is acceptable. */
export function passwordProblem(password) {
  if (password.length < 8) return 'Password must be at least 8 characters';

  const missing = [];
  if (!/[a-z]/.test(password)) missing.push('a lowercase letter');
  if (!/[A-Z]/.test(password)) missing.push('an uppercase letter');
  if (!/[0-9]/.test(password)) missing.push('a number');
  if (![...password].some((c) => SYMBOLS.includes(c))) missing.push(`a symbol such as ! @ # $ %`);

  if (missing.length === 0) return null;
  return `Password must include ${missing.join(', ')}`;
}
